import { IOrderItem } from "../../types/orders";

export const getTotal = (items: IOrderItem[]) =>
  items.reduce((acc, item) => {
    // Usa is_canceled ao invés de status
    if (!item.is_canceled) {
      return (acc += item.amount * item.cost);
    }
    return acc;
  }, 0);
